import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppConfig } from '../app.config';
import { DIMBO_CONSTANT } from '../utils/constant';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenancePlanService {
  domain: string;
  constructor(
    private http: HttpClient, 
    private apiconfig :AppConfig,
    private httpservice:HttpService,
    private cacheService: CacheService,
    private httpService: HttpService
    ) { 
      var apipath='';
        if(this.apiconfig.mpsaFlag==='N'){
          apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        }

      this.domain = apipath+this.apiconfig.apiPath;
    }


  getMaintenancePlan(params: any) {
    //let domain = this.apiconfig.apiPath;
    let vin = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    //vin = 'VF30U9HR8AS274264';
    const queryParams = this.httpService.prepareQueryParams(params);
    let finalURL = this.domain +'/'+vin+DIMBO_CONSTANT.MAINTENANCE_PLAN + queryParams;
   // console.log('Final URL: ', finalURL);
    return this.httpservice.getWithObserve(finalURL);
  }

  verifyCustomer(params: any) {
    //let domain = this.apiconfig.apiPath;
    const queryParams = this.httpService.prepareQueryParams(params);
    let finalURL = this.domain +''+DIMBO_CONSTANT.CUSTOMER_VERIFY + queryParams;
    //console.log('Final URL: ', finalURL);
    return this.httpservice.getWithObserve(finalURL);  
  }

  addServicePlan(param :any) {
    let finalURL = this.domain+'/services';
    return this.httpservice.postWithObserve(finalURL, param);
    //return of({'response': 'demo response'});
  }

}
